import { type BuildQuizListItem } from '../../../form/schema/BuildQuizListSchema';

/**
 * 보기 이미지 업로드가 끝난 시점에 그 보기의 현재 `imageUrl` 경로를 key 로 다시 찾는다.
 * 업로드 중 보기가 삭제·이동(드래그, 설정 탭 전환 시 빈 보기 정리)되면 시작 시점 index 가
 * 다른 보기를 가리키므로, AI 선지 채움(applyOptionFill)처럼 key 로 찾고 없으면 버린다.
 */
export const getChoiceImageUrlPath = (
  quizList: BuildQuizListItem[],
  quizId: string,
  choiceKey: string,
) => {
  const quizIndex = quizList.findIndex(quiz => quiz.id === quizId);
  if (quizIndex < 0) return;

  const choiceIndex = quizList[quizIndex].multipleData.choiceList.findIndex(
    choice => choice.key === choiceKey,
  );
  if (choiceIndex < 0) return;

  return `quizList.${quizIndex}.multipleData.choiceList.${choiceIndex}.imageUrl` as const;
};
